<script lang="ts" setup>
  import Chip from '@leaflink/stash/Chip.vue';
  import { computed } from 'vue';

  import { PaymentMethodStatuses } from '@/constants/settings';

  interface PaymentMethodStatusLabelProps {
    status: PaymentMethodStatuses;
    isManual?: boolean;
  }
  const props = withDefaults(defineProps<PaymentMethodStatusLabelProps>(), {
    isManual: false,
  });

  const isLinked = computed(() => props.status === 'linked');
  const isError = computed(() => props.status === 'error');
</script>

<template>
  <Chip v-if="isLinked" color-scheme="green" shade="light">Linked</Chip>
  <Chip v-else-if="isError" color-scheme="red" shade="light">Errored</Chip>
  <!-- Default to Pending for unrecognized statuses -->
  <Chip v-else color-scheme="orange" shade="light">Pending</Chip>
</template>
